import type { SVGProps } from 'react';

/**
 * Schematic-style ground symbol: a vertical stem over three shortening horizontal bars. Drawn
 * with `currentColor` so it follows the surrounding text color.
 *
 * @param props - Standard SVG element props (className, style, etc.).
 * @returns The ground icon SVG element.
 */
export function GroundIcon(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			viewBox='0 0 16 16'
			width='1em'
			height='1em'
			fill='none'
			stroke='currentColor'
			strokeWidth={1.5}
			strokeLinecap='round'
			aria-hidden
			{...props}
		>
			<path d='M8 2v6' />
			<path d='M3 8h10' />
			<path d='M5.5 11h5' />
			<path d='M7.25 14h1.5' />
		</svg>
	);
}
